import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import ReactNotify from 'react-notify';
import EprzystankiSelect from "./components/EprzystankiSelect";
import TrasyService from "../trasy/TrasyService";
import EPrzystankiService from "./EPrzystankiService";
import EPrzystankiTable from "./components/EPrzystankiTable";
import EprzystankiForm from "./components/EprzystankiForm";
import vTrasyService from "../definicjeTras/vTrasyService";
import LSService from "../../../../utilities/localStorageService/LSService";
import TopIf from "../../../../componentsTopsa/if/TopIf";

export default class EPrzystankiContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasa: null,
            trasy: [],
            eprzystanki: [],
            eprzystanek: null,
            przystankiNaTrasie: [],
            pokazFormularz: false,
            trasaLS: null
        };
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.pobierzEprzystankiPoTrasie = this.pobierzEprzystankiPoTrasie.bind(this)
        this.pobierzPrzystankiNaTrasie = this.pobierzPrzystankiNaTrasie.bind(this)
        this.zamknijForm = this.zamknijForm.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onClickUsunPrzystanek = this.onClickUsunPrzystanek.bind(this)
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
    }

    componentDidMount() {
        this.pobierzTrasy()
    }

    pobierzTrasy() {

        TrasyService.getTrasy().then(function (response) {
            if (response.data.content.length > 0) {

                let trasa = response.data.content[0]
                if (Boolean(LSService.pobierzIdTrasyDoEprzystankow())) {
                    let tr = response.data.content.find(t => t.idTr == LSService.pobierzIdTrasyDoEprzystankow())
                    if (Boolean(tr)) {
                        trasa = tr
                    }
                    LSService.usunIdTrasyDoEprzystankow()
                }

                this.setState({
                    trasy: response.data.content,
                 //   trasa: trasa,
                 //   trasaLS: trasa
                })

                this.pobierzEprzystankiPoTrasie(trasa)
                this.pobierzPrzystankiNaTrasie(trasa)
            }
        }.bind(this))
    }

    pobierzEprzystankiPoTrasie(trasa = this.state.trasa) {
        EPrzystankiService.getEprzystankiPoTrasie(trasa.idTr).then(function (response) {
            this.setState({eprzystanki: response.data})
        }.bind(this))
    }

    pobierzPrzystankiNaTrasie(trasa) {
        vTrasyService.getWszytskiePrzystankiNaTrasie(trasa.idTr).then(function (response) {
            let arr = Array.from(response.data, item => {
                return {
                    ...item,
                    info: item.nazMi + ' ' + item.nazPr,
                    rezerwacja: false,
                }
            })
            this.setState({przystankiNaTrasie: arr})
        }.bind(this))
    }

    onChangeTrasa(e) {
        this.setState({trasa: e})
        this.pobierzEprzystankiPoTrasie(e)
        this.pobierzPrzystankiNaTrasie(e)
    }

    zamknijForm() {
        this.setState({
            eprzystanek: null,
            pokazFormularz: false
        })
    }

    onClickZapisz(fromObject, toArray, czyEdycja) {
        if (Boolean(this.state.trasa)) {
            let data = {
                "idPrOd": fromObject.idPr,
                "idTr": this.state.trasa.idTr,
                "przystanki": Array.from(toArray, item => {
                    return {
                        "idPr": item.idPr,
                        "rezerwacja": item.rezerwacja
                    }
                })
            }

            EPrzystankiService.addEprzystanek(data).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie zmieniono eprzystanki", "", 3000);
                    this.pobierzEprzystankiPoTrasie(this.state.trasa);
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas zmiany eprzystanków ", "", 3000);
                }
                this.zamknijForm();
            }.bind(this))

        }
    }

    onClickEdytuj(obj) {

        let eprzystanek = obj;
        eprzystanek.przystanekOd = Object.assign(eprzystanek.przystanekOd, {info: eprzystanek.przystanekOd.nazMi + ' ' + eprzystanek.przystanekOd.nazPr})
        eprzystanek.przystanki.forEach(przystanek => {
            przystanek = Object.assign(przystanek, {info: przystanek.nazMi + ' ' + przystanek.nazPr})
        })

        this.setState({
            eprzystanek: eprzystanek,
            pokazFormularz: true
        })

    }

    onClickUsunPrzystanek(obj) {
        if (window.confirm('Czy na pewno chcesz usunąć cały rekord?')) {
            let data = {
                "idPrOd": obj.przystanekOd.idPr,
                "idTr": this.state.trasa.idTr,
                "przystanki": []
            }
            EPrzystankiService.addEprzystanek(data).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie usunięto rekord", "", 3000);
                    this.pobierzEprzystankiPoTrasie(this.state.trasa);
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas usuwania rekordu ", "", 3000);
                }
            }.bind(this))

        }
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks}
                              currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'DefinicjeContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-trasami',
                                    text: 'Zarządzanie trasami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-trasami/eprzystanki', text: 'e-przystanki'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        {
                            !Boolean(this.state.pokazFormularz) ?
                                <Col sm={12}>
                                    <EprzystankiSelect trasy={this.state.trasy} handleSelectTrasa={this.onChangeTrasa}
                                                       handleClickPokaz={() => this.setState({pokazFormularz: true})} trasaLS={this.state.trasaLS}/>
                                </Col>
                                :
                                <Col xs={12}>
                                    <EprzystankiForm przystanki={this.state.przystankiNaTrasie} handleClickAnuluj={this.zamknijForm}
                                                     handleZapisz={this.onClickZapisz} eprzystanek={this.state.eprzystanek} trasa={this.state.trasa}/>
                                </Col>
                        }

                        <Col xs={12}>
                            <TopIf isTrue={Boolean(this.state.trasa)}>
                            <EPrzystankiTable data={this.state.eprzystanki} handleEdytuj={this.onClickEdytuj} trasa={this.state.trasa}
                                              handleUsun={this.onClickUsunPrzystanek}/>
                            </TopIf>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/ePrzystanki/EPrzystankiContainer.js